/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Flipallbutton2Inputs */

const id_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balik semua`)
};

const ms_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balik semua`)
};

const da_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vend alle`)
};

const de_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle umdrehen`)
};

const en_us2_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flip all`)
};

const es_es2_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltear todo`)
};

const es_mx2_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltear todo`)
};

const fil_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-flip lahat`)
};

const fr_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout retourner`)
};

const it_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capovolgi tutto`)
};

const hu_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes megfordítása`)
};

const nl_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles omdraaien`)
};

const no_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vend alle`)
};

const pl_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odwróć wszystkie`)
};

const pt_br2_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virar tudo`)
};

const pt_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverter tudo`)
};

const ro_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversează toate`)
};

const fi_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käännä kaikki`)
};

const sv_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vänd alla`)
};

const vi_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lật tất cả`)
};

const tr_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tümünü çevir`)
};

const cs_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otočit vše`)
};

const bg_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обърни всички`)
};

const ru_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перевернуть всё`)
};

const uk_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перегорнути всі`)
};

const ar_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قلب الكل`)
};

const hi_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी पलटें`)
};

const th_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พลิกทั้งหมด`)
};

const ja_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて反転`)
};

const zh_cn2_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部翻转`)
};

const zh_hant1_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部翻轉`)
};

const ko_sandboxes_flipallbutton2 = /** @type {(inputs: Sandboxes_Flipallbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모두 뒤집기`)
};

/**
* | output |
* | --- |
* | "Flip all" |
*
* @param {Sandboxes_Flipallbutton2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_flipallbutton2 = /** @type {((inputs?: Sandboxes_Flipallbutton2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Flipallbutton2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_flipallbutton2(inputs)
	if (locale === "ms") return ms_sandboxes_flipallbutton2(inputs)
	if (locale === "da") return da_sandboxes_flipallbutton2(inputs)
	if (locale === "de") return de_sandboxes_flipallbutton2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_flipallbutton2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_flipallbutton2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_flipallbutton2(inputs)
	if (locale === "fil") return fil_sandboxes_flipallbutton2(inputs)
	if (locale === "fr") return fr_sandboxes_flipallbutton2(inputs)
	if (locale === "it") return it_sandboxes_flipallbutton2(inputs)
	if (locale === "hu") return hu_sandboxes_flipallbutton2(inputs)
	if (locale === "nl") return nl_sandboxes_flipallbutton2(inputs)
	if (locale === "no") return no_sandboxes_flipallbutton2(inputs)
	if (locale === "pl") return pl_sandboxes_flipallbutton2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_flipallbutton2(inputs)
	if (locale === "pt") return pt_sandboxes_flipallbutton2(inputs)
	if (locale === "ro") return ro_sandboxes_flipallbutton2(inputs)
	if (locale === "fi") return fi_sandboxes_flipallbutton2(inputs)
	if (locale === "sv") return sv_sandboxes_flipallbutton2(inputs)
	if (locale === "vi") return vi_sandboxes_flipallbutton2(inputs)
	if (locale === "tr") return tr_sandboxes_flipallbutton2(inputs)
	if (locale === "cs") return cs_sandboxes_flipallbutton2(inputs)
	if (locale === "bg") return bg_sandboxes_flipallbutton2(inputs)
	if (locale === "ru") return ru_sandboxes_flipallbutton2(inputs)
	if (locale === "uk") return uk_sandboxes_flipallbutton2(inputs)
	if (locale === "ar") return ar_sandboxes_flipallbutton2(inputs)
	if (locale === "hi") return hi_sandboxes_flipallbutton2(inputs)
	if (locale === "th") return th_sandboxes_flipallbutton2(inputs)
	if (locale === "ja") return ja_sandboxes_flipallbutton2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_flipallbutton2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_flipallbutton2(inputs)
	return ko_sandboxes_flipallbutton2(inputs)
});
export { sandboxes_flipallbutton2 as "sandboxes.flipAllButton" }